// import { DesignationList } from "components/Designation";
import { FC } from "react";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { DesignationList } from "../../components/DesignationList";


export interface IDesignationListPage {}

export const DesignationListPage: FC<IDesignationListPage> = (
  props: IDesignationListPage
) => {
  return (
    <AuthenticatedLayout
      pageTitle="Designation List"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Designation", navigateTo: "/company/designation/list" },
      ]}
      mainContents={<DesignationList />}
    />
  );
};
